/* ==========================================================================
   reviews-badge.js — The Park Wholesale
   Floating reviews badge (snippets/reviews-badge.liquid).
   - Copies rating + review count from the Reviews.io rating bar on the page
     (no extra request). If the numbers can't be read, the badge never shows.
   - Gives the trust-bar link one spoken name from the live numbers
     ("Rated 4.8 out of 5 from 5,072 reviews…").
   - The badge itself is visual only (aria-hidden, not in the Tab order): the
     same information is already on the page as the trust-bar link.
   - Visible once the trust bar (#TrustBar) has scrolled off the top, all the
     way to the end of the page.
   - Shows the Reviews.io logo copied from the rating bar (text fallback).
   - Click opens the Reviews.io profile in a new tab. Fallback (no URL):
     scrolls back to the trust bar below the sticky header and highlights it.
   - ✕ hides it for 24 hours (localStorage timestamp).
   ========================================================================== */
(function () {
  'use strict';

  var bar = document.getElementById('TrustBar');
  if (!bar) return;
  var widget = bar.querySelector('.reviews-io-rating-bar-widget');
  var barLink = bar.querySelector('.cts-bar__reviews-link');
  var badge = document.querySelector('[data-rv-badge]');
  if (badge && !('IntersectionObserver' in window)) badge = null;
  var KEY = 'tpw:reviewsBadgeHiddenUntil';
  var DAY = 24 * 60 * 60 * 1000;

  var hasData = false;
  var barPassed = false;

  function dismissed() {
    try { return Number(localStorage.getItem(KEY) || 0) > Date.now(); } catch (e) { return false; }
  }

  function update() {
    if (!badge) return;
    var show = hasData && barPassed && !dismissed();
    badge.hidden = !show;
    document.documentElement.classList.toggle('rv-badge-on', show);
  }

  /* ---------- read the numbers from the Reviews.io widget ---------- */
  function readNumbers() {
    if (!widget) return false;
    var text = (widget.textContent || '').replace(/\s+/g, ' ');
    var rating = text.match(/(\d(?:\.\d)?)\s*\/\s*5/);
    var count = text.match(/([\d,]+)\s+Reviews?/i);
    if (!rating || !count) return false;

    // the stars carry the precise score (title="4.82 Stars") — use it for the star fill
    var stars = widget.querySelector('[title$="Stars"]');
    var precise = stars ? parseFloat(stars.getAttribute('title')) : NaN;
    var value = precise > 0 && precise <= 5 ? precise : parseFloat(rating[1]);
    if (!(value > 0 && value <= 5)) return false;

    // one clean spoken name for the trust-bar link, built from the live numbers
    if (barLink) {
      barLink.setAttribute('aria-label',
        'Rated ' + rating[1] + ' out of 5 from ' + count[1] + ' reviews. Read our reviews' +
        (barLink.target === '_blank' ? ' (opens in a new tab)' : ''));
    }

    if (!badge) return true;
    badge.querySelector('[data-rv-rating]').textContent = rating[1];
    badge.querySelector('[data-rv-count]').textContent = count[1];
    badge.querySelector('[data-rv-fill]').style.width = (value / 5 * 100) + '%';
    copyLogo();
    hasData = true;
    update();
    return true;
  }

  /* ---------- Reviews.io logo: reuse the one the widget already shows ---------- */
  function copyLogo() {
    var slot = badge.querySelector('[data-rv-brand]');
    if (!slot || slot.querySelector('img, svg')) return;
    var logo = widget.querySelector('img[src*="review" i], img[alt*="review" i], svg[class*="logo" i], [class*="logo" i] svg, [class*="Logo"] svg, [class*="logo" i] img');
    if (!logo) return;
    var copy = logo.cloneNode(true);
    copy.removeAttribute('id');
    copy.setAttribute('aria-hidden', 'true');
    copy.setAttribute('focusable', 'false');
    if (copy.tagName === 'IMG') copy.setAttribute('alt', '');
    copy.removeAttribute('width');
    copy.removeAttribute('height');
    copy.classList.add('rv-badge__logo');
    slot.replaceChildren(copy);
  }

  if (widget && !readNumbers()) {
    var watcher = new MutationObserver(function () {
      if (readNumbers()) watcher.disconnect();
    });
    watcher.observe(widget, { childList: true, subtree: true, characterData: true });
    window.setTimeout(function () { watcher.disconnect(); }, 15000);
  }

  if (!badge) return;

  /* ---------- when to show ---------- */
  new IntersectionObserver(function (entries) {
    var e = entries[0];
    // passed = bar is fully above the viewport (not just "not yet reached")
    barPassed = !e.isIntersecting && e.boundingClientRect.top < 0;
    update();
  }).observe(bar);

  /* ---------- click: back to the trust bar, clear of the sticky header ---------- */
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var link = badge.querySelector('[data-rv-link]');
  // with a Reviews.io URL the link simply opens it in a new tab; only the fallback scrolls
  if (link.hasAttribute('data-rv-scroll')) link.addEventListener('click', function (event) {
    event.preventDefault();
    var header = document.querySelector('.site-header');
    // the header comes back (fixed) while scrolling up, so leave room for it
    var headerHeight = header ? header.offsetHeight : 0;
    var top = bar.getBoundingClientRect().top + window.pageYOffset - headerHeight - 16;
    window.scrollTo({ top: Math.max(top, 0), behavior: reduceMotion.matches ? 'auto' : 'smooth' });

    bar.classList.remove('is-highlighted');
    void bar.offsetWidth; // restart the highlight if clicked twice
    bar.classList.add('is-highlighted');
    window.setTimeout(function () { bar.classList.remove('is-highlighted'); }, 2200);
  });

  /* ---------- close for 24 hours ---------- */
  badge.querySelector('[data-rv-close]').addEventListener('click', function () {
    try { localStorage.setItem(KEY, String(Date.now() + DAY)); } catch (e) { /* private mode: hides for this page only */ }
    badge.hidden = true;
    document.documentElement.classList.remove('rv-badge-on');
    hasData = false; // stays hidden for the rest of this page view
  });
})();